import React from "react";
import Navigation from "./Navigation";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";

const App = () => {
  const queryClient = new QueryClient();
  return (
    <>
      <QueryClientProvider client={queryClient} >
        <BrowserRouter>
          <Navigation />
        </BrowserRouter>
      </QueryClientProvider>

    </>
  );
};

export default App;
